export const USER_ACTION_PARAMS = {
    group: 'user_action',
    sub_group: 'website_action',
    action: {
        type: 'click'
    }
};
